import { DeviceFamily } from '@core/referential/device-family.enum'
import { EquipmentRef } from '@core/referential/equipment-ref.enum'
import { WaterType } from '@core/referential/water-type.enum'
import { z } from 'zod'

import { numberOrStringToNumberSchema } from '@shared/schema/utils'

export const GetEquipmentByIdPathParameterSchema = z.object({
  siteId: numberOrStringToNumberSchema,
  equipmentId: z.string().uuid(),
})

const LocationsSchema = z.object({
  buildingId: numberOrStringToNumberSchema.optional(),
  floorId: numberOrStringToNumberSchema.optional(),
  spaceId: numberOrStringToNumberSchema.optional(),
})

const FilesSchema = z.array(
  z.object({
    id: z.string().uuid(),
    name: z.string(),
    type: z.string(),
    link: z.string(),
    equipmentId: z.string().uuid().nullable().optional(),
    date: z.string().optional(),
  }),
)

export const EquipmentSchema = z.object({
  equipmentId: z.string().uuid(),
  deviceId: z.string().uuid().nullable(),
  name: z.string(),
  category: z.string(),
  group: z.boolean().nullable(),
  useCase: z.string(),
  siteId: numberOrStringToNumberSchema,
  companyId: z.number(),
  equipmentRefId: numberOrStringToNumberSchema,
  equipmentRefName: z.nativeEnum(EquipmentRef),
  waterNetworkId: numberOrStringToNumberSchema.nullable(),
  canHaveDevice: z.boolean(),
  metadata: z
    .object({
      description: z.string().nullable().optional(),
      model: z.string().nullable().optional(),
      number: z.string().nullable().optional(),
      position: z.string().nullable().optional(),
    })
    .nullable()
    .optional(),
  deviceWaterType: z.nativeEnum(WaterType).optional().nullable(),
  deviceName: z.string().nullable(),
  deviceMetadata: z
    .object({
      deviceFamily: z.nativeEnum(DeviceFamily).nullable().optional(),
    })
    .nullable()
    .optional(),
})

export const GetEquipmentByIdResponseSchema = EquipmentSchema.merge(
  z.object({
    files: FilesSchema,
    locations: LocationsSchema,
  }),
)

export type GetEquipmentByIdPathParameter = z.infer<typeof GetEquipmentByIdPathParameterSchema>
export type GetEquipmentByIdResponse = z.input<typeof GetEquipmentByIdResponseSchema>
